import React from "react";
import {
    faComment,
    faFaceFrown,
    faFaceSmile,
} from "@fortawesome/pro-regular-svg-icons";
import { H2 } from "@singlestore/fusion/components/typography";
import { useWasThisHelpfulContext } from "contexts/WasThisHelpfulContext";

import { FaIcon } from "components/FaIcon/FaIcon";
import { WasThisHelpfulPopover } from "components/layout/WasThisHelpful/WasThisHelpfulPopover";

import { sendFeedbackEvent } from "utils/feedback";

import "./WasThisHelpful.scss";

export function WasThisHelpful() {
    const { setSentiment } = useWasThisHelpfulContext();

    const handleYesClick = async () => {
        const newSentiment = "positive";

        setSentiment(newSentiment);
        sendFeedbackEvent("wtah_click", {
            feedback_type: "yes_no_click",
            sentiment: newSentiment,
        });
    };

    const handleNoClick = async () => {
        const newSentiment = "negative";

        setSentiment(newSentiment);
        sendFeedbackEvent("wtah_click", {
            feedback_type: "yes_no_click",
            sentiment: newSentiment,
        });
    };

    const handleCommentClick = async () => {
        setSentiment("neutral");
    };

    return (
        <div className="was-this-helpful-container">
            <H2
                variant="heading-1"
                color="mid-contrast"
                mb="1-5x"
                textTransform="uppercase"
            >
                Was this article helpful?
            </H2>

            <div className="buttons">
                <WasThisHelpfulPopover
                    triggerContent={<FaIcon icon={faFaceSmile} />}
                    sentiment="positive"
                    triggerLabel="Yes"
                    onClick={handleYesClick}
                />
                <WasThisHelpfulPopover
                    triggerContent={<FaIcon icon={faFaceFrown} />}
                    sentiment="negative"
                    triggerLabel="No"
                    onClick={handleNoClick}
                />
                <WasThisHelpfulPopover
                    triggerContent={<FaIcon icon={faComment} />}
                    sentiment="neutral"
                    triggerLabel="Comment"
                    onClick={handleCommentClick}
                />
            </div>
        </div>
    );
}
